"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountWithCosmosAndSecret = void 0;
const base_1 = require("./base");
const cosmos_1 = require("./cosmos");
const secret_1 = require("./secret");
const deepmerge_1 = __importDefault(require("deepmerge"));
class AccountWithCosmosAndSecret extends base_1.AccountSetBase {
    constructor(eventListener, chainGetter, chainId, queriesStore, opts) {
        super(eventListener, chainGetter, chainId, queriesStore, opts);
        this.eventListener = eventListener;
        this.chainGetter = chainGetter;
        this.chainId = chainId;
        this.queriesStore = queriesStore;
        this.opts = opts;
        this.cosmos = new cosmos_1.CosmosAccount(this, chainGetter, chainId, queriesStore);
        this.secret = new secret_1.SecretAccount(this, chainGetter, chainId, queriesStore);
    }
}
exports.AccountWithCosmosAndSecret = AccountWithCosmosAndSecret;
AccountWithCosmosAndSecret.defaultMsgOpts = deepmerge_1.default(cosmos_1.AccountWithCosmos.defaultMsgOpts, secret_1.AccountWithSecret.defaultMsgOpts);
//# sourceMappingURL=cosmos-secret.js.map